import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { OrganizationDataComponent } from './organization-data.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.organization-data', {
            url: '/organization-data',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Organization Data'
            },
            ncyBreadcrumb: {
                label: 'Dati Organizzazione',
                parent: 'registration.account-data'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<organization-data flex="100"></organization-data>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const OrganizationDataModule: string = ng
    .module('organization-data', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('organizationData', OrganizationDataComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/organization-data/organization-data.module.ts